/**
 * Deeply compares two objects for equality, keeping track of visited objects to prevent infinite recursion in cyclic structures.
 */
export function deepEquals(a, b, visited = new Set()) {
    if (visited.has(a) || visited.has(b)) {
        return true;
    }
    if (typeof a !== 'object' || typeof b !== "object" || a === null || b === null) {
        return a === b;
    }
    if (a["forceResponsive"] || b["forceResponsive"]) {
        return false;
    }
    visited.add(a);
    visited.add(b);
    if (Array.isArray(a)) {
        return Array.isArray(b)
            && a.length === b.length
            && a.every((item, index) => deepEquals(item, b[index], visited));
    }
    const keys = Object.keys(a);
    return keys.length === Object.keys(b).length
        && keys.every((key) => deepEquals(a[key], b[key], visited));
}
//# sourceMappingURL=deepEquals.js.map